import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Render from 'components/render';
// import { IS_DEMO} from 'constants/constants';
// import { MIXPANEL_EVENT_NAMES } from 'constants/mixpanelEventNames';
import routes from 'constants/routes';
import { trackMixpanelEvent } from 'helpers/mixpanel-init';
import { NoDataIcon } from 'styles/assets/icons';

import styles from '../universal-search.module.scss';
import { getMixpanelPageName } from './helpers';
import { Contract, ContractName, SearchResultsSectionProps } from './interface';
import RecentSearches from './RecentSearches';
import SearchResult from './searchResult';
import TrendingContracts from './trending-contracts';
import ViewAllBtn from './viewAllBtn';

const SearchResultsSection = (props: SearchResultsSectionProps) => {
  const {
    searchData,
    clearSearch,
    onRowClick,
    noResultsFound,
    searchTerm,
    recentSearches,
  } = props;
  const { t } = useTranslation(['headerFooter', 'trading']);
  const contracts = Object.keys(searchData) as ContractName[];

  const trackMarketsPage = () => {
    trackMixpanelEvent('Search - Markets Page Clicked', {
      source: getMixpanelPageName(),
    });
    clearSearch();
  };

  /*
    API call to getUniversalSearchResults is only made when searchTerm.length is > 1.
    So unless searchTerm has required length we need to show Trending Contracts only.
   */
  const showTrendingContractsAndRecentSearches =
    searchTerm.length <= 1 || contracts.length === 0;
  const showNoResults = noResultsFound && searchTerm.length > 1;
  const showTableHeader = showTrendingContractsAndRecentSearches || !noResultsFound;
  const showSearchResults = !showTrendingContractsAndRecentSearches;

  // const handleDesktopBannerClick = () => {
  //   onClose();
  //   trackMixpanelEvent(MIXPANEL_EVENT_NAMES.OPTIONS_SPREAD_STRIP_CLICK, {
  //     Source: 'search',
  //   });
  // };

  // const handleMobileBannerClick = () => {
  //   trackMixpanelEvent(MIXPANEL_EVENT_NAMES.OPTIONS_SPREAD_STRIP_CLICK, {
  //     Source: 'search',
  //   });
  // };

  return (<>
    {/* <Render when={!IS_DEMO}>
      <MediaQuery query={device.up.md}>
        <Link
          data-testid="searchDropDownBannerDesktop"
          to={routes.optionsCombos.markets}
          onClick={handleDesktopBannerClick}
        >
          <img
            src={searchDropDownBannerDesktop}
            className={styles.bannerDesktop}
            alt="searchdropdownBanner"
          />
        </Link>
      </MediaQuery>
    </Render>

    <Render when={!IS_DEMO&& !IS_INDIAN_EXCHANGE}>
      <MediaQuery query={device.down.md}>
        <Link
          data-testid="searchDropDownBannerMobile"
          to={routes.optionsCombos.markets}
          onClick={handleMobileBannerClick}
        >
          <img
            src={searchDropDownBannerMobile}
            className={styles.bannerMobile}
            alt="searchdropdownBanner"
          />
        </Link>
      </MediaQuery>
    </Render> */}
    <Render when={showNoResults}>
      <div className={styles['no-data-container']}>
        <div className={styles['no-data']}>
          <NoDataIcon />
          <div>{t('headerFooter:header.noData')}</div>
        </div>

        <div className={styles.pleaseVisitSection}>
          <Trans i18nKey="headerFooter:header.pleaseVisitMarkets">
            <Link
              data-testid="universal-search-link-to-markets"
              to={`${routes.webAppHome}`}
              className={styles.highlight}
              onClick={trackMarketsPage}
            />
          </Trans>
        </div>
      </div>
    </Render>
    <Render when={showTableHeader}>
      <div className={styles.contracts}>
        <div className={styles.name}>{t('headerFooter:header.contracts')}</div>
        <div>24h {t('trading:dropdownTableHeaders.chg')}</div>
      </div>
      <hr className={styles.divider} />
    </Render>
    <Render when={showTrendingContractsAndRecentSearches}>
      <div className={styles['default-container']}>
        <TrendingContracts onRowClick={onRowClick} />
        <RecentSearches recentSearches={recentSearches!} onRowClick={onRowClick} />
      </div>
    </Render>
    <Render when={showSearchResults}>
      <div className={styles['search-results-container']}>
        {contracts.map(key => {
          const { data, count } = searchData[key] as Contract;
          if (data.length > 0) {
            return (
              (<div
                key={key}
                className={styles['category-container']}
                data-palette="SearchResultsSection">
                <div>
                  <div className={styles['side-heading']}>
                    <div>
                      {t(
                        `headerFooter:header.tradeMenu.${
                          key === 'move' ? 'straddle' : key
                        }`
                      )}
                      <span className={styles['side-heading-length']}>{count}</span>
                    </div>
                    {key === 'options' && (
                      <ViewAllBtn
                        optionsData={data}
                        clearSearch={clearSearch}
                        searchTerm={searchTerm}
                      />
                    )}
                  </div>
                  {data.map(contract => {
                    const {
                      symbol,
                      change_in_24h: changeIn24h,
                      product_id: productId,
                      contract_type: contractType,
                    } = contract;
                    return (
                      <SearchResult
                        key={productId}
                        productId={productId as number}
                        symbol={symbol as string}
                        contractType={contractType as string}
                        changeIn24h={changeIn24h as number}
                        onRowClick={() => onRowClick(contract)}
                      />
                    );
                  })}
                </div>
                <hr className={styles.divider} />
              </div>)
            );
          }
          return null;
        })}
      </div>
    </Render>
  </>);
};

export default SearchResultsSection;
